import { z } from 'zod';
/**
 * Cross-cutting response envelopes per the sfcompute API guidelines.
 *
 * https://github.com/sfcompute/prompts/blob/main/api-guidelines.md
 *
 * Zod schema + inferred type pairs so endpoints can declare their
 * response shape once and the frontend can derive the TS type via
 * `z.infer<typeof X>`.
 */
/**
 * Generic list envelope.
 *
 * The TS type and the zod factory share a name (TS lets a value and a
 * type sit in the same identifier when they're declared separately):
 *
 *   const Schema = ListResponse(BusinessFunction);  // zod schema
 *   const body: ListResponse<Foo> = { ... };        // TS type
 *
 * The factory form is used by per-entity zod modules so `hono/client`
 * infers the array type end-to-end. The TS type form is used by
 * pre-zod routes that hand-construct envelopes.
 */
export function ListResponse(item) {
    return z.object({
        object: z.literal('list'),
        url: z.string(),
        has_more: z.boolean(),
        data: z.array(item),
    });
}
export const ApiErrorType = z.enum([
    'api_error',
    'invalid_request_error',
    'idempotency_error',
]);
export const ApiErrorDetail = z.object({
    field: z.string().optional(),
    code: z.string().optional(),
    message: z.string().optional(),
});
export const ApiErrorBody = z.object({
    error: z.object({
        type: ApiErrorType,
        message: z.string(),
        details: z.array(ApiErrorDetail).optional(),
        request_id: z.string().optional(),
    }),
});
//# sourceMappingURL=envelope.js.map